import BigNumber from "bignumber.js";
import {RootStore} from "./";
import {action, makeObservable, observable, runInAction} from "mobx";
import {injectable } from "inversify";
import {ExchangeOrdersType, ExchangeOrderType} from "../utils/graphql";
import { toUpper } from "lodash";


@injectable()
export class OrdersStore {

    @observable orderCurrent: ExchangeOrderType[];
    limit: number;
    pageNo: number;
    @observable orderHistory?: ExchangeOrderType[];
    @observable sell: ExchangeOrdersType[];
    @observable buy: ExchangeOrdersType[];
    @observable selectBuy: ExchangeOrdersType;
    @observable selectSell: ExchangeOrdersType;
    @observable maxCurrencyBuy: number;
    @observable maxCountOrdersBuy: number;
    @observable maxCountOrderSell: number;

    get api() {
        return this.rootStore.api;
    }

    public constructor(protected rootStore: RootStore) {
        makeObservable(this);
      
    }

    @action 
    setMaxCurrencyBuy(value) {
        this.maxCurrencyBuy = value;
    }

    
    @action 
    getMaxCurrencyBuy(symbol: string, limit: number) {
        this.maxCurrencyBuy;
    }

    @action
    getMaxCountOrdersBuy() {
        let count = 0;
        this.buy.map((item) => {
            count += (Number(item.amounts) - Number(item.amountMyOrder));
        });
        this.maxCountOrdersBuy = count;
    }

    @action
    async setSelectData(one: ExchangeOrdersType, direct: string) {
            let tt = {
                amounts: 0,
                price: 0,
                turnovers: 0
            }
            console.log(one)
            if (direct=="BUY") {    
                // console.log('BUY')
                // this.sell.map(item=>{
                //         if (Number(item.price)<=Number(one.price)) {
                //             tt.amounts += Number(item.amounts)
                //             tt.price = item.price 
                //             tt.turnovers += Number(item.turnovers)
                //         }
                // })
                // tt.price = tt.turnovers / tt.amounts 

                // runInAction(() => {
                //     this.selectBuy = tt;
                // })
            } else {
                console.log('SELL', tt);
                this.buy.map(item=>{
                    if (Number(item.price)>=Number(one.price)) {
                        if (Number(item.amountMyOrder) > Number(item.amounts)) {
                            // tt.amounts = 0;
                            return;
                        }

                        tt.amounts += Number(item.amounts);
                        tt.amounts -= Number(item.amountMyOrder);

                        tt.price = Number(item.price);
                        tt.turnovers += Number(item.turnovers);

                        if (Number(item.amountMyOrder) > 0) {
                            let price = new BigNumber(item.price);
                            let amount = new BigNumber(item.amountMyOrder ? item.amountMyOrder : 0);
                            let result = price.times(amount).decimalPlaces(8).toNumber();

                            tt.turnovers -= result;
                            if (Number(item.amountMyOrder) > Number(item.amounts)) {
                                tt.turnovers = 0;
                            }
                        }
                    }
                });

                tt.turnovers = Number((tt.turnovers).toFixed(8));
                tt.amounts = Number((tt.amounts).toFixed(8));
                if (tt.amounts) {
                    let turnovers = new BigNumber(tt.turnovers);
                    tt.price = (turnovers.dividedBy(tt.amounts).decimalPlaces(8, BigNumber.ROUND_HALF_UP)).toNumber();
                }

                runInAction(() => {
                    this.selectSell = tt;
                })
            }
    }


    @action
    async getOrdersBook(symbol: string, limit: number) {
        const orders = await this.api.sdk.getBooks({symbol,limit})
        runInAction(() => {
                this.buy = orders.books.buy;
                this.sell = orders.books.sell;
            }
        );
    }



    @action
    async getOrdersCurrent(symbol: string, limit: number, pageNo: number) {
        const orders = await this.api.sdk.getOrderCurrent({symbol, limit, pageNo});
        if (orders.orderCurrent.items.length === 0 && this.orderCurrent.length !== 0 ) {
            return;
        }
        this.orderCurrent = orders.orderCurrent.items;
        this.limit = orders.orderCurrent.limit;
        this.pageNo = orders.orderCurrent.pageNo;
        runInAction(() => {
                this.orderCurrent = orders.orderCurrent.items;
                this.limit = orders.orderCurrent.limit;
                this.pageNo = orders.orderCurrent.pageNo;
            }
        )
    }

    @action
    async getOrdersHistory(symbol: string, limit: number, pageNo: number) {
        const orders = await this.api.sdk.getOrderHistory({symbol, limit, pageNo})
        runInAction(() => {
                this.orderHistory = orders.orderHistory.items;
                this.limit = orders.orderHistory.limit;
                this.pageNo = orders.orderHistory.pageNo;
            }
        );
    }

    @action
    async cancelOrder(orderId: string) {
        let index = this.orderCurrent.findIndex((one)=>one.orderId==orderId)
        this.orderCurrent.slice(index);
        await this.api.sdk.onCancelOrder({pk: orderId})
    }

    @action
    async createOrder(symbol:string, direction: string, type: string, amount: number,price: number,turnover: number) {
        await this.api.sdk.createOrder({symbol, direction, type, amount,price,turnover})
    }

}
